let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("atCAk")).then(() => parcelRequire('aUqA7'));